module.exports = __webpack_public_path__ + "img/edit.833ccaa2.svg";